import styled from 'styled-components';
import {wrap} from '../../../textEditor/editorWrapper/EditorWrapper.css';

export const smsEditor = styled.div`
    ${wrap}{
        width: 100%;
        height: 100%;
        margin-block: 20px;
        padding-bottom: 40px;
    } 
`;
